// extracted by mini-css-extract-plugin
export var alertIcon = "_rj-0";